import { memo } from "react";
import { Position } from "reactflow";
import { editIcon } from "../../../assets/icons";
import { useDispatch, useSelector } from "react-redux";
import { convertDictToList } from "../../../helpers";
import AutoMapperRenderObjectProperties from "../../../pages/DataModels/ServiceFields/MapperModal/RenderAutoMapperObjectProperties";
import { AUTO_MAPPER_OPERATIONS } from "../../../constants";
import { setAutoMapper, selectAutoMapper } from "../../../pages/DataModels";

const {
  SOURCE_NODE,
  RESPONSE_NODE,
  SHOULD_SHOW_RESPONSE_EDITOR,
  SHOULD_SHOW_SOURCE_EDITOR,
  SET_SOURCE_EXPANDED_KEYS,
  SET_RESPONSE_EXPANDED_KEYS,
} = AUTO_MAPPER_OPERATIONS;
const SOURCE = "source";

const AutoMapperNode = ({ title, target }) => {
  const dispatch = useDispatch();
  const { mapperObject, expandedKeys, responseObject, sourceObject } =
    useSelector(selectAutoMapper);
  const { source: expandedSourceKeys, response: expandedResponseKeys } =
    expandedKeys;

  const setParamToBeExpanded = (key) => {
    const flattenMapperKeys = Object.values(mapperObject)
      .map((each) => each.split("."))
      .flat();
    const updatedKeys = [
      ...new Set([
        ...flattenMapperKeys,
        ...(target === SOURCE ? expandedSourceKeys : expandedResponseKeys),
        key,
      ]),
    ];
    dispatch(
      setAutoMapper({
        [`${target}ExpandedKeys`]: updatedKeys,
        operation:
          target === SOURCE
            ? SET_SOURCE_EXPANDED_KEYS
            : SET_RESPONSE_EXPANDED_KEYS,
      })
    );
  };

  const dataObject = target === SOURCE ? sourceObject : responseObject;
  const properties = convertDictToList(dataObject);

  return (
    <>
      <div className="flex items-center justify-between bg-slate-300 rounded-md text-black min-h-12">
        <div className="m-2 font-medium">{title}</div>
        <button
          type="button"
          className="rounded-md bg-slate-800 w-6 h-6 p-1 m-2"
          onClick={() => {
            dispatch(
              setAutoMapper({
                shouldShowModal: true,
                operation:
                  target === SOURCE
                    ? SHOULD_SHOW_SOURCE_EDITOR
                    : SHOULD_SHOW_RESPONSE_EDITOR,
              })
            );
          }}
        >
          <img src={editIcon} alt="cross" />
        </button>
      </div>
      <div className="px-2 text-black text-sm min-h-5">
        <AutoMapperRenderObjectProperties
          properties={properties}
          paramToBeExpanded={
            target === SOURCE ? expandedSourceKeys : expandedResponseKeys
          }
          handleExpandedParams={setParamToBeExpanded}
          target={target}
          position={target === SOURCE ? Position.Right : Position.Left}
          nodeId={target === SOURCE ? SOURCE_NODE : RESPONSE_NODE}
        />
      </div>
    </>
  );
};

export default memo(AutoMapperNode);
